import { useState } from "react";
import { Star, Play } from "lucide-react";
import SectionHeader from "@/components/SectionHeader";
const VideoTestimonials = () => {
  const [activeVideo, setActiveVideo] = useState<number | null>(null);

  const testimonials = [
    { id: "1138154850", thumbnail: "https://vumbnail.com/1138154850.jpg" },
    { id: "946520739", thumbnail: "https://vumbnail.com/946520739.jpg" },
  ];

  return (
    <section className="py-12 md:py-20 relative overflow-hidden">
      {/* Background decoration */}
      <div className="absolute top-1/2 left-1/4 w-64 h-64 bg-accent/5 rounded-full blur-3xl pointer-events-none" />
      <div className="absolute bottom-0 right-1/4 w-80 h-80 bg-blue-500/5 rounded-full blur-3xl pointer-events-none" />
      
      <div className="container mx-auto px-4 md:px-6 relative">
        <div className="max-w-5xl mx-auto">
          <SectionHeader
            badge="Echte Kundenstimmen"
            title="Das sagen unsere Kunden"
            highlightedWord="Kunden"
            description="Überzeugen Sie sich selbst – echte Stimmen von Unternehmen, die mit uns zusammengearbeitet haben."
            className="mb-12"
          />
          
          <div className="grid md:grid-cols-2 gap-6 md:gap-8">
            {testimonials.map((video, index) => (
              <div 
                key={video.id}
                className="relative aspect-video rounded-2xl overflow-hidden shadow-2xl group cursor-pointer transform hover:-translate-y-1 transition-all duration-300"
                onClick={() => setActiveVideo(activeVideo === index ? null : index)}
              >
                {/* Glow effect */}
                <div className="absolute -inset-0.5 bg-gradient-to-r from-accent/30 to-blue-500/30 rounded-2xl blur opacity-0 group-hover:opacity-100 transition-opacity duration-300" />
                
                <div className="relative h-full rounded-2xl overflow-hidden border border-border/50">
                  {activeVideo === index ? (
                    <iframe
                      src={`https://player.vimeo.com/video/${video.id}?autoplay=1&title=0&byline=0&portrait=0&dnt=1`}
                      className="absolute inset-0 w-full h-full"
                      allow="autoplay; fullscreen; picture-in-picture"
                      allowFullScreen
                    />
                  ) : (
                    <>
                      <img 
                        src={video.thumbnail} 
                        alt="Kundenstimme"
                        loading="lazy"
                        decoding="async"
                        className="absolute inset-0 w-full h-full object-cover transition-transform duration-700 group-hover:scale-110"
                      />
                      <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/30 to-transparent" />
                      
                      {/* Play button - consistent with main page */}
                      <div className="absolute inset-0 flex items-center justify-center">
                        <div className="bg-background/80 backdrop-blur-sm rounded-full p-4 md:p-6 group-hover:bg-background/90 transition-all duration-300 group-hover:scale-110">
                          <Play className="w-6 h-6 md:w-8 md:h-8 text-accent fill-accent" />
                        </div>
                      </div>
                      
                      {/* Bottom info */}
                      <div className="absolute bottom-0 left-0 right-0 p-5 bg-gradient-to-t from-black/80 to-transparent">
                        <div className="flex items-center gap-2">
                          <div className="flex items-center gap-0.5">
                            {[...Array(5)].map((_, i) => (
                              <Star key={i} className="w-3 h-3 fill-accent text-accent" />
                            ))}
                          </div>
                          <span className="text-white/80 text-sm">•</span>
                          <span className="text-white font-medium text-sm">Video ansehen</span>
                        </div>
                      </div>
                    </>
                  )}
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default VideoTestimonials;
